import React from "react";
import { makeStyles } from "@material-ui/core";
import { PositionAxes } from "./positionAxes";
import { ZoomButtons } from "./zoomButtons";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    height: "100%",
    width: "100%",
    position: "absolute",
    zIndex: 1,
    top: 0,
    pointerEvents: "none",
  },
  spacer: {
    display: "flex",
    alignSelf: "flex-end",
    height: 0,
    flexGrow: 2,
    flexShrink: 0,
  },
}));

export function Hud() {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <PositionAxes />
      <div className={classes.spacer} />
      <ZoomButtons />
    </div>
  );
}
